import ShipperOrdersCell from './container';

export default ShipperOrdersCell;
